var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_3788_33227)" } }, [
        _c("path", {
          attrs: {
            d:
              "M17.5 9.16667V2.5H10.8333L13.575 5.24167L5.24167 13.575L2.5 10.8333V17.5H9.16667L6.425 14.7583L14.7583 6.425L17.5 9.16667Z",
            fill: "currentColor"
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_3788_33227" } }, [
          _c("rect", { attrs: { width: "20", height: "20", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }